import { createAsyncThunk } from '@reduxjs/toolkit'
import { format } from 'date-fns'
import { APIError, authenticatedRequest, getExceptionPayload } from '../axiosConfiguration'
import { InvoiceData, InvoiceDocumentFilters, InvoiceDocuments, InvoiceSearchRequest } from '../type/invoices'
import * as layoutActions from './layout'

export const getInvoiceData = createAsyncThunk<InvoiceData, InvoiceSearchRequest, { rejectValue: APIError }>(
  'invoice/getInvoiceData',
  async (requestPayload, { dispatch, rejectWithValue }) => {
    dispatch(layoutActions.startLoading())

    let URLParameters = new URLSearchParams()

    if (requestPayload.filter.hasOwnProperty('startFromDate')) {
      URLParameters.append('from_date', format(requestPayload.filter.startFromDate as Date, 'yyyy-MM-dd'))
    }

    if (requestPayload.filter.hasOwnProperty('endToDate')) {
      URLParameters.append('to_date', format(requestPayload.filter.endToDate as Date, 'yyyy-MM-dd'))
    }

    try {
      const instance = await authenticatedRequest()
      const res = await instance.get<InvoiceData>('invoice', {
        params: URLParameters,
      })

      dispatch(layoutActions.endLoading())
      if (res.data.record_info !== ''){
        dispatch(layoutActions.showToast({ summary: res.data.record_info , severity: 'warn' }))
      }
      return res.data
    } catch (error) {
      const err = getExceptionPayload(error, 'invoice:error.getInvoiceData')

      dispatch(layoutActions.endLoading())
      dispatch(layoutActions.showToast({ summary: err.message, severity: 'error' }))

      return rejectWithValue(err)
    }
  },
)

export const getInvoiceDocument = createAsyncThunk<InvoiceDocuments, InvoiceDocumentFilters, { rejectValue: APIError }>(
  '/invoice-search/get-document',
  async (query, { dispatch, rejectWithValue }) => {
    dispatch(layoutActions.startLoading())

    try {
      const instance = await authenticatedRequest()
      const queryParams = new URLSearchParams()
      queryParams.append('company_code', query.companyCode.toString())
      queryParams.append('customer_code', query.customerCode.toString())
      queryParams.append('invoice_identifier', query.documentIdentifier.toString())
      const res = await instance.get<InvoiceDocuments>(`/invoice/get-document?${queryParams.toString()}`) //, requestPayload)

      dispatch(layoutActions.endLoading())

      return res.data
    } catch (error) {
      const err = getExceptionPayload(error, `orderTracking:error.getOrderTrackingDocument`, {orderNumber: query.documentIdentifier})
      console.log(err)
      dispatch(layoutActions.endLoading())
      dispatch(layoutActions.showToast({ summary: err.message, severity: 'error' }))

      return rejectWithValue(err)
    }
  },
)
